var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_16874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 60,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.18896H66V66.189H6V6.18896Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_16874)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5722 49.0461C60.7555 49.0461 61.7151 48.0867 61.7151 46.9033V12.6175C61.7151 11.4341 60.7555 10.4747 59.5722 10.4747H25.2865C24.103 10.4747 23.1436 11.4341 23.1436 12.6175V46.9033C23.1436 48.0867 24.103 49.0461 25.2865 49.0461H59.5722ZM66.0008 46.9033C66.0008 50.4535 63.1225 53.3318 59.5722 53.3318H25.2865C21.7361 53.3318 18.8579 50.4535 18.8579 46.9033V12.6175C18.8579 9.06714 21.7361 6.18896 25.2865 6.18896H59.5722C63.1225 6.18896 66.0008 9.06714 66.0008 12.6175V46.9033Z",
    fill: "#F30002"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14286 19.0469C9.32632 19.0469 10.2857 20.0063 10.2857 21.1897V59.7612C10.2857 60.3294 10.5115 60.8746 10.9134 61.2766C11.3152 61.6782 11.8602 61.904 12.4286 61.904H51C52.1833 61.904 53.1429 62.8636 53.1429 64.0469C53.1429 65.2302 52.1833 66.1897 51 66.1897H12.4286C10.7236 66.1897 9.08847 65.5126 7.88289 64.307C6.67729 63.1015 6 61.466 6 59.7612V21.1897C6 20.0063 6.95939 19.0469 8.14286 19.0469Z",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 21.1897C36 20.0063 36.9594 19.0469 38.1429 19.0469H51C52.1833 19.0469 53.1429 20.0063 53.1429 21.1897V34.0469C53.1429 35.2303 52.1833 36.1897 51 36.1897C49.8167 36.1897 48.8571 35.2303 48.8571 34.0469V23.3326H38.1429C36.9594 23.3326 36 22.3732 36 21.1897Z",
    fill: "#F30002"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.514 19.6745C53.3506 20.5114 53.3506 21.8681 52.514 22.705L35.371 39.8478C34.5341 40.6847 33.1774 40.6847 32.3405 39.8478C31.5037 39.011 31.5037 37.6542 32.3405 36.8174L49.4832 19.6745C50.3202 18.8377 51.677 18.8377 52.514 19.6745Z",
    fill: "#F30002"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.bf9de356500a7cc9b1794b33167e3695.svg";
export { ForwardRef as ReactComponent };